import moment from "moment";
import * as React from "react";
import {connect} from "react-redux";
import {Action, Dispatch} from "redux";
import {Field, formValueSelector, InjectedFormProps, reduxForm,} from "redux-form";
import {frontEndConfig} from "../../../../../config/config";
import {companyConfig} from "../../../../../config/language/ja-JP/domain/model_text";
import {Company} from "../../../../../domain/model/company";
import {createDayArray, createMonthArray,} from "../../../../../util/commonFuntion";
import {
    createAddressOptionDom,
    createOptions,
    createRequiredOptionItem,
} from "../../../../../util/select_option_function";
import * as Validator from "../../../../../util/validation";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import StyledAvatarDropZone from "../../../../common/atom/drop_zone/styled_avatar_drop_zone";
import ErrorText from "../../../../common/atom/text/error_text";
import Paragraph from "../../../../common/atom/text/paragraph";
import DatepickerWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/datepicker_wrapper";
import MonthDaysWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/month_days_wrapper";
import YearWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/year_wrapper";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupMultiSelectConnectRf from "../../../../common/molecular/form_group/form_group_multi_select_connect_rf";
import FormGroupSelectConnectRf from "../../../../common/molecular/form_group/form_group_select_connect_rf";
import FormGroupTextareaConnectRf from "../../../../common/molecular/form_group/form_group_textarea_connect_rf";
import {AppState} from "../../../../store/app_state";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

const validate = (values: any) => {
    const errors: any = {};
    return errors;
};

// ToDo: 1900年指定が必須か、確認後、UtilFunctionに統合する
const createYearsArray = (): string[] => {
    // 現在の年から1900年迄の年配列を作成する
    const yearStart: number = Number(moment().year().toString());
    const yearEnd: number = 1900;
    const yearDiff: number = yearStart - yearEnd;
    const resArray: string[] = [];
    resArray.push("");

    for (let i = 0; i <= yearDiff; i++) {
        resArray.push((yearStart - i).toString());
    }
    return resArray;
};

interface IStateProps {
    initialValues:
        | {
        company: Company | null;
        logoURLFileObject?: File;
    }
        | undefined;
    formValues: any;
}

interface IProps extends IStateProps {
    companyIsLoading: boolean;
    companyError?: any;
}

interface IState {
    imageError: string | null;
}

export class ClientMypageMainCompanyForm extends React.Component<
    IProps & InjectedFormProps<{}, IProps>,
    IState
> {
    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {
            imageError: null,
        };
    }

    public componentWillUpdate(nextProps: any, nextState: any): void {
        // 更新実行後の初期化処理
        if (
            this.props.formValues != null &&
            this.props.initialValues.company &&
            nextProps.initialValues.company.gsLogoURL !==
            this.props.initialValues.company.gsLogoURL
        ) {
            URL.revokeObjectURL(this.props.formValues.preview);
            this.props.change("logoURLFileObject", null);
        }
    }

    public componentWillUnmount(): void {
        // Make sure to revoke the data uris to avoid memory leaks
        if (this.props.formValues != null) {
            URL.revokeObjectURL(this.props.formValues.preview);
        }
    }

    public render(): JSX.Element {
        const {anyTouched, invalid, handleSubmit, pristine, submitting} =
            this.props;

        const company: Company | null = this.props.initialValues
            ? this.props.initialValues.company
            : null;

        if (!company) {
            return <div>データがありません</div>;
        }

        const logoURL: string = company.getLogoURL();

        const updateLogoURL: string | null = this.props.formValues
            ? this.props.formValues.preview
            : null;

        let res: JSX.Element;

        // 編集ページ
        res = (
            <React.Fragment>
                <form name="ClientMypageMainCompanyForm" onSubmit={handleSubmit}>
                    <StyledAvatarDropZone
                        name="ClientMypageMainCompanyForm-dropzone"
                        handleOnDrop={this.handleOnDrop}
                        updateIconURL={updateLogoURL}
                        iconURL={logoURL}
                    />

                    <FormFieldWrapper>
                        <Field
                            label="会社名"
                            placeholder="入力してください"
                            name="company.name"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.companyName, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <DatepickerWrapper>
                            <YearWrapper>
                                <Field
                                    label="設立年月日：年"
                                    name={`company.establishedAt.year`}
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    validate={[Validator.required]}
                                    require={true}
                                >
                                    {createAddressOptionDom(createYearsArray())}
                                </Field>
                            </YearWrapper>
                            <MonthDaysWrapper>
                                <Field
                                    label="設立年月日：月"
                                    name={`company.establishedAt.month`}
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    validate={[Validator.required]}
                                    require={true}
                                >
                                    {createAddressOptionDom(createMonthArray())}
                                </Field>
                            </MonthDaysWrapper>
                            <MonthDaysWrapper>
                                <Field
                                    label="設立年月日：日"
                                    name={`company.establishedAt.day`}
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    validate={[Validator.required]}
                                    require={true}
                                >
                                    {createAddressOptionDom(createDayArray())}
                                </Field>
                            </MonthDaysWrapper>
                        </DatepickerWrapper>
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label="郵便番号"
                            placeholder="1234567(ハイフンなし)"
                            name="company.postalCode"
                            component={FormGroupInputConnectRf}
                            type="number"
                            validate={[Validator.postalCode, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="所在地"
                            placeholder="入力してください"
                            name="company.place"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.place, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="企業 WEB URL"
                            placeholder="入力してください"
                            name="company.webURL"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[
                                Validator.url,
                                Validator.passwordCount,
                                Validator.required,
                            ]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="業種"
                            name="company.business"
                            component={FormGroupMultiSelectConnectRf}
                            type="select-multiple"
                            isMulti={true}
                            options={createOptions(companyConfig.businessList)}
                            validate={[Validator.requiredForMultiSelect]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="従業員規模"
                            name="company.employeeScale"
                            component={FormGroupSelectConnectRf}
                            validate={[Validator.required]}
                            require={true}
                            defaultValue={"1"}
                        >
                            {createRequiredOptionItem(companyConfig.employeeScaleList)}
                        </Field>
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="CEO名前"
                            placeholder="入力してください"
                            name="company.representativeName"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.representativeName]}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="資本金"
                            placeholder="入力してください"
                            name="company.capitalStock"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.capitalStock, Validator.capitalStockCount]}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="会社紹介メッセージ"
                            placeholder="例）当社は、ファッション業界において革新的なリーダーシップを発揮し、高品質で手頃な価格の衣料品を提供しています。私たちのミッションは、世界中の人々に快適でスタイリッシュな日常着を提供することです。シンプルで機能的なデザインと優れた技術を融合させ、幅広い年齢層やライフスタイルに適応する製品ラインを展開しています。持続可能な素材と製造プロセスに注力し、環境への影響を最小限に抑える努力を続けています。グローバルなネットワークを通じて、多様な文化や地域に根ざした店舗展開を行い、顧客に優れたサービスとショッピング体験を提供しています。"
                            name="company.introduction"
                            component={FormGroupTextareaConnectRf}
                            type="text"
                            validate={[Validator.introduction]}
                            style={{height: "200px"}}
                        />
                    </FormFieldWrapper>

                    <Paragraph bold={true}>請求先情報</Paragraph>

                    <FormFieldWrapper>
                        <Field
                            label="請求先名"
                            placeholder="入力してください"
                            name="company.accordingCompanyName"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.accordingCompanyName]}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="請求先郵便番号"
                            placeholder="入力してください"
                            name="company.accordingCompanyPostalCode"
                            component={FormGroupInputConnectRf}
                            type="number"
                            validate={[Validator.accordingCompanyPostalCode]}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="請求先住所"
                            placeholder="入力してください"
                            name="company.accordingCompanyAddress"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.accordingCompanyAddress]}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label="請求先部署名"
                            placeholder="入力してください"
                            name="company.invoiceDepartmentName"
                            component={FormGroupInputConnectRf}
                            type="text"
                        />
                    </FormFieldWrapper>

                    {anyTouched && invalid && (
                        <SubmitErrorTextWrapper>
                            <ErrorText>入力を完了してください</ErrorText>
                        </SubmitErrorTextWrapper>
                    )}

                    <SubmitButtonWrapper>
                        <CancelButtonWrapper>
                            <BtnLinkCancelSmall to="/client/mypage/company">
                                キャンセル
                            </BtnLinkCancelSmall>
                        </CancelButtonWrapper>
                        <BtnCorporateLarge
                            name="ClientMypageMainCompanyForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={pristine || submitting || invalid}
                        >
                            設定を保存
                        </BtnCorporateLarge>
                    </SubmitButtonWrapper>
                </form>
            </React.Fragment>
        );

        return res;
    }

    private handleOnDrop = (acceptedFiles: any, rejectedFiles: any): void => {
        try {
            this.setState({imageError: null});

            if (rejectedFiles.length > 1) {
                throw new Error("複数のファイルが選択されました");
            } else if (
                rejectedFiles.length > 0 &&
                rejectedFiles[0].size > uploadFileMaxSize
            ) {
                throw new Error("ファイルサイズオーバ");
            } else {
                this.props.change("logoURLFileObject", acceptedFiles[0]);
            }
        } catch (error) {
            this.setState({imageError: error.message});
        }
    };
}

const selector = formValueSelector("ClientMypageMainCompanyForm");

const mapStateToProps = (state: AppState) => {
    return {
        formValues: selector(state, "logoURLFileObject"),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm({
    form: "ClientMypageMainCompanyForm",
    validate,
})(connect(mapStateToProps, mapDispatchToProps)(ClientMypageMainCompanyForm));



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/edit_company/client_mypage_main_company_form.tsx